import { useQuery } from 'react-apollo';

import { countries as countriesQuery } from '../graphql/queries/countries';

const useCountries = () => {
  const { loading, data: { countries } = {} } = useQuery(countriesQuery);

  return {
    loading,
    countries: countries?.records ?? [],
  };
};

export default useCountries;
